module.exports = __webpack_public_path__ + "static/media/sim-card.818e3bce.svg";